module.exports = __webpack_public_path__ + "static/media/feature-interview-offer@3x.94f50be9.png";